module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-8.d5014002.jpg";